import { render, staticRenderFns } from "./MobileFreebie.vue?vue&type=template&id=619306d5"
import script from "./MobileFreebie.vue?vue&type=script&lang=js"
export * from "./MobileFreebie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports